import { API_ENDPOINTS } from '@/constants/api'
import { apiClient } from '@/lib/api/client'

/**
 * Auth API Service
 * Handles authentication-related API calls
 */
export const authApi = {
  /**
   * Login with username and password
   * @param {Object} credentials - { username, password }
   * @returns {Promise<Object>} User data
   */
  login: async (credentials) => {
    const response = await apiClient.post(API_ENDPOINTS.AUTH.LOGIN, credentials)
        return response
  },

  /**
   * Logout current user
   * @returns {Promise<void>}
   */
  logout: async () => {
    const response = await apiClient.post(API_ENDPOINTS.AUTH.LOGOUT)
      return response
  },

  /**
   * Get current user profile
   * @returns {Promise<Object>} User data
   */
  me: async () => {
    const response = await apiClient.get(API_ENDPOINTS.AUTH.ME)
      return response
  },

  /**
   * Update current user profile
   * @param {Object|FormData} data - Profile data to update (supports FormData for file uploads)
   * @returns {Promise<Object>} Updated user data
   */
  updateProfile: async (data) => {
    const response = await apiClient.patch(API_ENDPOINTS.AUTH.UPDATE_PROFILE, data)
    return response
  },

  /**
   * Change user password
   * @param {Object} data - { old_password, new_password, new_password_confirm }
   * @returns {Promise<Object>} Response
   */
  changePassword: async (data) => {
    const response = await apiClient.post(API_ENDPOINTS.AUTH.CHANGE_PASSWORD, data)
    return response
  },
}

export default authApi
